// @flow

import { getConfiguratorSettings } from './main';

import type { State } from '../reducers';

type GlobalState = {
  configuratorSettings: State,
};

type Vbmr = $PropertyType<State, 'vbmr'>;

export const getVbmrSettings = (state: GlobalState): Vbmr => {
  const vbmrSettings = getConfiguratorSettings(state).vbmr;
  if (!vbmrSettings) {
    throw new Error('Missing Vbmr settings in configuratorSettings store.');
  }
  return vbmrSettings;
};

export const getShowActivateOverlay = (state: GlobalState): number => (
  Number(getVbmrSettings(state).show_activate_overlay)
);

type ActivateTitle = $PropertyType<Vbmr, 'activate_title'>;
export const getActivateTitle = (state: GlobalState): ActivateTitle => (
  getVbmrSettings(state).activate_title
);

type ActivateDescription = $PropertyType<Vbmr, 'activate_description'>;
export const getActivateDescription = (state: GlobalState): ActivateDescription => (
  getVbmrSettings(state).activate_description
);

type ActivateAcceptButtonText = $PropertyType<Vbmr, 'activate_accept_button_text'>;
export const getActivateAcceptButtonText = (state: GlobalState): ActivateAcceptButtonText => (
  getVbmrSettings(state).activate_accept_button_text
);

type ActivateDeclineButtonText = $PropertyType<Vbmr, 'activate_decline_button_text'>;
export const getActivateDeclineButtonText = (state: GlobalState): ActivateDeclineButtonText => (
  getVbmrSettings(state).activate_decline_button_text
);

export const getShowDeactivateOverlay = (state: GlobalState): number => (
  Number(getVbmrSettings(state).show_deactivate_overlay)
);

type DeactivateTitle = $PropertyType<Vbmr, 'deactivate_title'>;
export const getDeactivateTitle = (state: GlobalState): DeactivateTitle => (
  getVbmrSettings(state).deactivate_title
);

type DeactivateDescription = $PropertyType<Vbmr, 'deactivate_description'>;
export const getDeactivateDescription = (state: GlobalState): DeactivateDescription => (
  getVbmrSettings(state).deactivate_description
);

type DeactivateAcceptButtonText = $PropertyType<Vbmr, 'deactivate_accept_button_text'>;
export const getDeactivateAcceptButtonText = (state: GlobalState): DeactivateAcceptButtonText => (
  getVbmrSettings(state).deactivate_accept_button_text
);

type DeactivateDeclineButtonText = $PropertyType<Vbmr, 'deactivate_decline_button_text'>;
export const getDeactivateDeclineButtonText = (state: GlobalState): DeactivateDeclineButtonText => (
  getVbmrSettings(state).deactivate_decline_button_text
);

type VbmrActiveText = $PropertyType<Vbmr, 'vbmr_active_text'>;
export const getVbmrActiveText = (state: GlobalState): VbmrActiveText => (
  getVbmrSettings(state).vbmr_active_text
);

export default null;
